//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export enum EmailReportTopic {
  INSIGHTS_WEEKLY = 'insights-weekly',
  INSIGHTS_MONTHLY = 'insights-monthly',

  EXAMPLE = 'example',
}

export enum EmailReportOutput {
  SENDGRID = 'Sendgrid',
}

export enum EmailReportingSortDir {
  ASC = 'Asc',
  DESC = 'Desc',
}

export enum EmailReportingSortKey {
  RECIPIENT = 'recipient',
  LAST_SENT = 'lastSent',
}
